import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { Field, FieldProps, useFormikContext } from 'formik';
import React, { ChangeEvent, FunctionComponent, useState } from "react";
import useTSHacks from '../../shared/tshacks/tshacks';
import { Option } from "./Option";

interface AdditionalProps {
  id: string
  fieldName: string
  fieldLabel: string
  fieldOptions: ()=> Option[]
  fieldValidator:  (value: any) => string
  required: boolean
}

type OptionFieldEditorProps = FieldProps & AdditionalProps;

const { getObjectProperty } = useTSHacks()

const OptionFieldEditor: FunctionComponent<OptionFieldEditorProps> = ({ id, required, fieldName, fieldLabel, fieldOptions, fieldValidator, ...props }) => {

  const [blured,setBlured] = useState(false)

  const { values, setFieldValue, errors, handleBlur} = useFormikContext();

  const onBlur = (event: any) => {
      handleBlur(event)
      setBlured(true)
  }

  return (
    <Autocomplete
      {...props}
      id={id}
      options={fieldOptions()}
      autoHighlight
      multiple={false}
      getOptionLabel={option => option?.label}
      value={fieldOptions().find(option => option.value === getObjectProperty(values,fieldName))||{ value: "", label: "" }}
      renderOption={option => (
        <React.Fragment>
          {option?.label}
        </React.Fragment>
      )}
      onChange={(event: ChangeEvent<{}>, value: Option | null) => {
          const safeValue=value||{ value: "", label: "" }
          setFieldValue(fieldName, safeValue.value,true)
      }}
      onBlur={onBlur}
      renderInput={props => (
        <Field
            {...props}
            helperText={blured && getObjectProperty(errors,fieldName)}
            error={blured && Boolean(getObjectProperty(errors,fieldName))}
            component={TextField}
            margin="dense"
            label={fieldLabel}
            variant="filled"
            type="text"
            name={fieldName}
            fullWidth
            validate={fieldValidator}
            required={required}
            InputLabelProps={{
                shrink: true,
            }}
        />
      )}
    />
  );
}

export default OptionFieldEditor;